"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _index = _interopRequireDefault(require("@/layout/index.vue"));
const prizesRouter = {
  path: '/prizes',
  component: _index.default,
  redirect: 'prizes',
  name: 'Prizes',
  meta: {
    title: 'prizes.title',
    icon: 'prize'
  },
  children: [{
    path: 'list',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require( /* webpackChunkName: "prizes-list" */'@/views/prizes/list.vue'))),
    name: 'PrizesList',
    meta: {
      title: 'prizes.title',
      noCache: true,
      icon: 'prize'
    }
  }, {
    path: 'edit/:id(\\d+)',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/prizes/manage.vue'))),
    name: 'EditPrize',
    props: {
      isEdit: true
    },
    meta: {
      title: 'prizes.edit',
      noCache: true,
      activeMenu: '/prizes/list',
      hidden: true
    }
  }, {
    path: 'add',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require('@/views/prizes/manage.vue'))),
    name: 'AddPrize',
    props: {
      isEdit: false
    },
    meta: {
      title: 'prizes.add',
      noCache: true,
      activeMenu: '/prizes/list',
      hidden: true
    }
  }]
};
var _default = exports.default = prizesRouter;